import React from 'react';
import PropTypes from 'prop-types';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { Box, ButtonBase } from '@material-ui/core';
import { Typography } from '@orijinworks/frontend-commons';
import {
  PLAN_STRUCTURE_EMPTY,
  PLAN_STRUCTURE_TEMPLATE,
} from '../../../../utils/case-plan-create.util';
import { usePlanStructureCardStyles } from './PlanStructureCard.styles';

/**
 * Selectable card for template vs empty plan structure.
 * Uses ButtonBase for Material-UI ripple on click.
 */
export const PlanStructureCard = ({
  structureType,
  title,
  description,
  selected,
  onSelect,
}) => {
  const classes = usePlanStructureCardStyles({ selected });
  const Icon =
    structureType === PLAN_STRUCTURE_TEMPLATE ? DashboardIcon : AutoAwesomeIcon;
  const RadioIcon = selected
    ? RadioButtonCheckedIcon
    : RadioButtonUncheckedIcon;

  return (
    <ButtonBase
      className={classes.root}
      focusRipple
      aria-pressed={selected}
      onClick={() => onSelect(structureType)}
    >
      <Box className={classes.controls}>
        <Box className={classes.iconBox}>
          <Icon className={classes.structureIcon} />
        </Box>
        <RadioIcon className={classes.radioIcon} />
      </Box>
      <Box className={classes.textBlock}>
        <Typography variant="body1" className={classes.title}>
          {title}
        </Typography>
        <Typography variant="body2" className={classes.description}>
          {description}
        </Typography>
      </Box>
    </ButtonBase>
  );
};

PlanStructureCard.propTypes = {
  structureType: PropTypes.oneOf([
    PLAN_STRUCTURE_TEMPLATE,
    PLAN_STRUCTURE_EMPTY,
  ]).isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  selected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default PlanStructureCard;
